/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/CookieBanner/Cookiebanner */ "./resources/scripts/components/CookieBanner/Cookiebanner.ts");
/* harmony import */ var _components_Consent_Consent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _components_LogoSlider_LogoSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @components/LogoSlider/LogoSlider */ "./resources/scripts/components/LogoSlider/LogoSlider.ts");



customElements.define("logo-slider", _components_LogoSlider_LogoSlider__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define("cookie-banner", _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_0__["default"]);
var consent = new _components_Consent_Consent__WEBPACK_IMPORTED_MODULE_1__["default"]();
consent.init();

/***/ }),

/***/ "./resources/scripts/components/Consent/Consent.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
// 3. Add Locales: en: "change_cookie_settings": "Change your cookie settings", da: "change_cookie_settings": "Tilpas dine cookie-indstillinger",
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
              }], function (error) {
                if (error) {
                  // eslint-disable-next-line no-console
                  console.error("Error loading features: ", error);
                  return;
                }
                // eslint-disable-next-line no-console
                console.log("Consent tracking API loaded");
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate("update");
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById("recall-consent");
              if (recallConsentElement) {
                recallConsentElement.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: "granted",
                analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              this.gtag("consent", state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem("consentSettings", JSON.stringify(consent));
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === "" && visitorConsent.analytics === "" && visitorConsent.marketing === "")) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }())
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/CookieBanner/Cookiebanner.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/CookieBanner/Cookiebanner.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CookieBanner)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CookieBanner = /*#__PURE__*/function (_HTMLElement) {
  function CookieBanner() {
    var _this;
    _classCallCheck(this, CookieBanner);
    _this = _callSuper(this, CookieBanner);
    _defineProperty(_this, "panelConsent", null);
    _defineProperty(_this, "panelDetails", null);
    _defineProperty(_this, "tabConsent", null);
    _defineProperty(_this, "tabDetails", null);
    _defineProperty(_this, "consentApiReady", false);
    _this.showConsentTab = _this.showConsentTab.bind(_this);
    _this.showDetailsTab = _this.showDetailsTab.bind(_this);
    _this.initSyncedCheckboxes = _this.initSyncedCheckboxes.bind(_this);
    _this.initConsentApis = _this.initConsentApis.bind(_this);
    _this.bindActionButtons = _this.bindActionButtons.bind(_this);
    _this.handleAllowAll = _this.handleAllowAll.bind(_this);
    _this.handleAllowSelected = _this.handleAllowSelected.bind(_this);
    _this.handleReject = _this.handleReject.bind(_this);
    _this.applyConsent = _this.applyConsent.bind(_this);
    _this.getSelections = _this.getSelections.bind(_this);
    _this.showBanner = _this.showBanner.bind(_this);
    _this.hideBanner = _this.hideBanner.bind(_this);
    _this.ensureGtag = _this.ensureGtag.bind(_this);
    _this.getOverlay = _this.getOverlay.bind(_this);
    _this.restoreSelections = _this.restoreSelections.bind(_this);
    return _this;
  }
  _inherits(CookieBanner, _HTMLElement);
  return _createClass(CookieBanner, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var recall, showBanner;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.tabConsent = this.querySelector("#tab-consent");
              this.tabDetails = this.querySelector("#tab-details");
              this.panelConsent = this.querySelector("#panel-consent");
              this.panelDetails = this.querySelector("#panel-details");
              if (this.tabConsent) this.tabConsent.addEventListener("click", this.showConsentTab);
              if (this.tabDetails) this.tabDetails.addEventListener("click", this.showDetailsTab);
              _context.n = 1;
              return this.initConsentApis();
            case 1:
              this.showConsentTab();
              this.initSyncedCheckboxes();
              this.seedSelectionsFromHtmlIfFirstVisit();
              _context.n = 2;
              return this.restoreSelections();
            case 2:
              this.bindActionButtons();
              recall = document.getElementById("recall-consent-banner");
              if (recall) {
                recall.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.showBanner();
                });
              }
              _context.n = 3;
              return this.checkConsentBannerInteraction();
            case 3:
              showBanner = _context.v;
              if (showBanner) this.showBanner();
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }() // Show banner if Shopify API isn't ready OR visitor hasn't made a choice yet
  }, {
    key: "checkConsentBannerInteraction",
    value: function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _window$Shopify;
        var _visitorConsent$prefe, _visitorConsent$analy, _visitorConsent$marke, visitorConsent, empty, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!this.consentApiReady || !((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.customerPrivacy) !== null && _window$Shopify !== void 0 && _window$Shopify.currentVisitorConsent))) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, true);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 2:
              visitorConsent = _context2.v;
              empty = ((_visitorConsent$prefe = visitorConsent.preferences) !== null && _visitorConsent$prefe !== void 0 ? _visitorConsent$prefe : "") === "" && ((_visitorConsent$analy = visitorConsent.analytics) !== null && _visitorConsent$analy !== void 0 ? _visitorConsent$analy : "") === "" && ((_visitorConsent$marke = visitorConsent.marketing) !== null && _visitorConsent$marke !== void 0 ? _visitorConsent$marke : "") === "";
              return _context2.a(2, empty);
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error("currentVisitorConsent() failed:", _t);
              return _context2.a(2, true);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
  }, {
    key: "showConsentTab",
    value: function showConsentTab() {
      if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
        this.panelConsent.classList.remove("tw:hidden!");
        this.panelConsent.classList.add("active");
        this.panelDetails.classList.add("tw:hidden!");
        this.panelDetails.classList.remove("active");
        this.tabConsent.classList.add("active");
        this.tabDetails.classList.remove("active");
      }
    }
  }, {
    key: "showDetailsTab",
    value: function showDetailsTab() {
      if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
        this.panelConsent.classList.add("tw:hidden!");
        this.panelConsent.classList.remove("active");
        this.panelDetails.classList.remove("tw:hidden!");
        this.panelDetails.classList.add("active");
        this.tabConsent.classList.remove("active");
        this.tabDetails.classList.add("active");
      }
    }
  }, {
    key: "initSyncedCheckboxes",
    value: function initSyncedCheckboxes() {
      var all = Array.from(this.querySelectorAll("input.ed-checkbox[data-consent]"));
      var onChange = function onChange(event) {
        var target = event.currentTarget;
        var key = target.dataset.consent;
        if (!key) return;
        var checked = target.checked;
        all.forEach(function (other) {
          if (other === target) return;
          if (other.dataset.consent !== key) return;
          if (!other.disabled) other.checked = checked;
        });
      };
      all.forEach(function (checkbox) {
        return checkbox.addEventListener("change", onChange);
      });
      var byKey = new Map();
      all.forEach(function (checkbox) {
        var key = checkbox.dataset.consent;
        if (!byKey.has(key)) byKey.set(key, []);
        byKey.get(key).push(checkbox);
      });
      Array.from(byKey.values()).forEach(function (group) {
        var source = group[0];
        group.slice(1).forEach(function (checkbox) {
          if (!checkbox.disabled) checkbox.checked = source.checked;
        });
      });
    }
  }, {
    key: "initConsentApis",
    value: function () {
      var _initConsentApis = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _window$gtag,
          _window,
          _window$gtag2,
          _window2,
          _window$gtag3,
          _window3,
          _window$Shopify2,
          _this3 = this;
        var localStorageCookieSelections, selections, defaultConsent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.ensureGtag();
              localStorageCookieSelections = localStorage.getItem("cookieSelections");
              selections = localStorageCookieSelections ? function () {
                try {
                  return JSON.parse(localStorageCookieSelections);
                } catch (_unused) {
                  return {
                    personalization: false,
                    marketing: false,
                    analytics: false
                  };
                }
              }() : {
                personalization: false,
                marketing: false,
                analytics: false
              };
              defaultConsent = {
                functionality_storage: "granted",
                analytics_storage: selections.analytics ? "granted" : "denied",
                personalization_storage: selections.personalization ? "granted" : "denied",
                ad_personalization: selections.personalization ? "granted" : "denied",
                ad_storage: selections.marketing ? "granted" : "denied",
                ad_user_data: selections.marketing ? "granted" : "denied",
                wait_for_update: 3000
              };
              (_window$gtag = (_window = window).gtag) === null || _window$gtag === void 0 || _window$gtag.call(_window, "consent", "default", defaultConsent);
              (_window$gtag2 = (_window2 = window).gtag) === null || _window$gtag2 === void 0 || _window$gtag2.call(_window2, "set", "ads_data_redaction", false);
              (_window$gtag3 = (_window3 = window).gtag) === null || _window$gtag3 === void 0 || _window$gtag3.call(_window3, "set", "url_passthrough", true);
              if ((_window$Shopify2 = window.Shopify) !== null && _window$Shopify2 !== void 0 && _window$Shopify2.loadFeatures) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return new Promise(function (resolve) {
                try {
                  window.Shopify.loadFeatures([{
                    name: "consent-tracking-api",
                    version: "0.1"
                  }], function (error) {
                    if (error) {
                      console.error("Error loading Shopify consent-tracking-api:", error);
                      resolve();
                      return;
                    }
                    _this3.consentApiReady = true;
                    resolve();
                    document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                      var _window$Shopify3, _window$Shopify3$curr, v, _t2;
                      return _regenerator().w(function (_context3) {
                        while (1) switch (_context3.p = _context3.n) {
                          case 0:
                            _context3.p = 0;
                            _context3.n = 1;
                            return (_window$Shopify3 = window.Shopify) === null || _window$Shopify3 === void 0 || (_window$Shopify3 = _window$Shopify3.customerPrivacy) === null || _window$Shopify3 === void 0 || (_window$Shopify3$curr = _window$Shopify3.currentVisitorConsent) === null || _window$Shopify3$curr === void 0 ? void 0 : _window$Shopify3$curr.call(_window$Shopify3);
                          case 1:
                            v = _context3.v;
                            if (v) {
                              _context3.n = 2;
                              break;
                            }
                            return _context3.a(2);
                          case 2:
                            _this3.setGroup("personalization", v.preferences === "yes");
                            _this3.setGroup("marketing", v.marketing === "yes");
                            _this3.setGroup("analytics", v.analytics === "yes");
                            _this3.saveSelections();
                            _context3.n = 4;
                            break;
                          case 3:
                            _context3.p = 3;
                            _t2 = _context3.v;
                            console.error("visitorConsentCollected handler error:", _t2);
                          case 4:
                            return _context3.a(2);
                        }
                      }, _callee3, null, [[0, 3]]);
                    })));
                  });
                } catch (e) {
                  console.error("loadFeatures threw:", e);
                  resolve();
                }
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function initConsentApis() {
        return _initConsentApis.apply(this, arguments);
      }
      return initConsentApis;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "ensureGtag",
    value: function ensureGtag() {
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) {
        window.gtag = function gtagShim() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          window.dataLayer.push(args);
        };
      }
    }
  }, {
    key: "bindActionButtons",
    value: function bindActionButtons() {
      var allowAllBtn = this.querySelector(".allow-all-btn");
      var allowSelectedBtn = this.querySelector(".allow-selected-btn");
      var rejectBtn = this.querySelector('[data-action="reject"]');
      if (allowAllBtn) allowAllBtn.addEventListener("click", this.handleAllowAll);
      if (allowSelectedBtn) allowSelectedBtn.addEventListener("click", this.handleAllowSelected);
      if (rejectBtn) rejectBtn.addEventListener("click", this.handleReject);
    }
  }, {
    key: "handleAllowAll",
    value: function handleAllowAll() {
      var shopify = {
        preferences: "yes",
        marketing: "yes",
        analytics: "yes"
      };
      var allCheckboxes = this.querySelectorAll("input.ed-checkbox[data-consent]");
      allCheckboxes.forEach(function (checkbox) {
        if (!checkbox.disabled) checkbox.checked = true;
      });
      this.applyConsent(shopify, true);
    }
  }, {
    key: "handleAllowSelected",
    value: function handleAllowSelected() {
      var _this$getSelections = this.getSelections(),
        personalization = _this$getSelections.personalization,
        marketing = _this$getSelections.marketing,
        analytics = _this$getSelections.analytics;
      var shopify = {
        preferences: personalization ? "yes" : "no",
        marketing: marketing ? "yes" : "no",
        analytics: analytics ? "yes" : "no"
      };
      this.applyConsent(shopify, true);
    }
  }, {
    key: "handleReject",
    value: function handleReject() {
      var shopify = {
        preferences: "no",
        marketing: "no",
        analytics: "no"
      };
      this.applyConsent(shopify, true);
    }
  }, {
    key: "seedSelectionsFromHtmlIfFirstVisit",
    value: function seedSelectionsFromHtmlIfFirstVisit() {
      var _this$querySelector, _this$querySelector2, _this$querySelector3;
      if (localStorage.getItem("cookieSelections")) return;
      var selections = {
        personalization: !!((_this$querySelector = this.querySelector('input.ed-checkbox[data-consent="personalization"]')) !== null && _this$querySelector !== void 0 && _this$querySelector.checked),
        marketing: !!((_this$querySelector2 = this.querySelector('input.ed-checkbox[data-consent="marketing"]')) !== null && _this$querySelector2 !== void 0 && _this$querySelector2.checked),
        analytics: !!((_this$querySelector3 = this.querySelector('input.ed-checkbox[data-consent="analytics"]')) !== null && _this$querySelector3 !== void 0 && _this$querySelector3.checked)
      };
      localStorage.setItem("cookieSelections", JSON.stringify(selections));
    }
  }, {
    key: "setGroup",
    value: function setGroup(key, checked) {
      var boxes = this.querySelectorAll("input.ed-checkbox[data-consent=\"".concat(key, "\"]"));
      boxes.forEach(function (cb) {
        if (!cb.disabled) cb.checked = checked;
      });
    }
  }, {
    key: "restoreSelections",
    value: function () {
      var _restoreSelections = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var raw, selections;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              raw = localStorage.getItem("cookieSelections");
              if (raw) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              try {
                selections = JSON.parse(raw);
                this.setGroup("personalization", selections.personalization);
                this.setGroup("marketing", selections.marketing);
                this.setGroup("analytics", selections.analytics);
              } catch (event) {
                console.warn("Invalid cookieSelections in localStorage; leaving HTML defaults.", event);
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function restoreSelections() {
        return _restoreSelections.apply(this, arguments);
      }
      return restoreSelections;
    }()
  }, {
    key: "saveSelections",
    value: function saveSelections() {
      var selections = this.getSelections();
      localStorage.setItem("cookieSelections", JSON.stringify(selections));
    }
  }, {
    key: "getSelections",
    value: function getSelections() {
      var _this4 = this;
      var isConsentChecked = function isConsentChecked(consentType) {
        var _this4$querySelector;
        return !!((_this4$querySelector = _this4.querySelector("input.ed-checkbox[data-consent=\"".concat(consentType, "\"]"))) !== null && _this4$querySelector !== void 0 && _this4$querySelector.checked);
      };
      return {
        personalization: isConsentChecked("personalization"),
        marketing: isConsentChecked("marketing"),
        analytics: isConsentChecked("analytics")
      };
    }
  }, {
    key: "applyConsent",
    value: function () {
      var _applyConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(shopify, hide) {
        var _window$gtag4, _window4, _window$Shopify4, _window$Shopify4$setT;
        var google;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              google = {
                functionality_storage: "granted",
                analytics_storage: shopify.analytics === "yes" ? "granted" : "denied",
                personalization_storage: shopify.preferences === "yes" ? "granted" : "denied",
                ad_personalization: shopify.preferences === "yes" ? "granted" : "denied",
                ad_storage: shopify.marketing === "yes" ? "granted" : "denied",
                ad_user_data: shopify.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              (_window$gtag4 = (_window4 = window).gtag) === null || _window$gtag4 === void 0 || _window$gtag4.call(_window4, "consent", "update", google);
              this.saveSelections();
              (_window$Shopify4 = window.Shopify) === null || _window$Shopify4 === void 0 || (_window$Shopify4 = _window$Shopify4.customerPrivacy) === null || _window$Shopify4 === void 0 || (_window$Shopify4$setT = _window$Shopify4.setTrackingConsent) === null || _window$Shopify4$setT === void 0 || _window$Shopify4$setT.call(_window$Shopify4, {
                analytics: shopify.analytics === "yes",
                marketing: shopify.marketing === "yes",
                preferences: shopify.preferences === "yes"
              });
              if (hide) this.hideBanner();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function applyConsent(_x, _x2) {
        return _applyConsent.apply(this, arguments);
      }
      return applyConsent;
    }()
  }, {
    key: "getOverlay",
    value: function getOverlay() {
      return this.querySelector("[data-cookie-overlay]") || this;
    }
  }, {
    key: "showBanner",
    value: function showBanner() {
      var element = this.getOverlay();
      element.removeAttribute("hidden");
      element.classList.remove("tw:hidden!");
    }
  }, {
    key: "hideBanner",
    value: function hideBanner() {
      var element = this.getOverlay();
      element.classList.add("tw:hidden!");
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/LogoSlider/LogoSlider.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/LogoSlider/LogoSlider.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ LogoSlider)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LogoSlider = /*#__PURE__*/function (_HTMLElement) {
  function LogoSlider() {
    var _this;
    _classCallCheck(this, LogoSlider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LogoSlider, [].concat(args));
    _defineProperty(_this, "logosContainer", null);
    _defineProperty(_this, "logoTrack", null);
    _defineProperty(_this, "intersectionObserver", void 0);
    return _this;
  }
  _inherits(LogoSlider, _HTMLElement);
  return _createClass(LogoSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.logosContainer = this.querySelector(".logos");
      this.logoTrack = this.querySelector(".logo-slider");
      if (!this.logosContainer || !this.logoTrack) {
        return;
      }
      // Respect reduced motion preferences
      var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      if (prefersReducedMotion.matches) {
        this.logoTrack.style.animation = "none";
        return;
      }
      // Ensure duplicated content exists at least once for seamless CSS animation
      if (!this.logoTrack.hasAttribute("data-duplicated")) {
        var children = Array.from(this.logoTrack.children);
        if (children.length > 0) {
          var fragment = document.createDocumentFragment();
          children.forEach(function (child) {
            fragment.appendChild(child.cloneNode(true));
          });
          this.logoTrack.appendChild(fragment);
          this.logoTrack.setAttribute("data-duplicated", "true");
        }
      }
      // Pause/resume on hover for robustness (CSS also handles this)
      this.logosContainer.addEventListener("mouseenter", function () {
        if (_this2.logoTrack) _this2.logoTrack.style.animationPlayState = "paused";
      });
      this.logosContainer.addEventListener("mouseleave", function () {
        if (_this2.logoTrack) _this2.logoTrack.style.animationPlayState = "running";
      });
      // Pause animation while offscreen to save CPU/GPU
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!_this2.logoTrack) return;
          _this2.logoTrack.style.animationPlayState = entry.isIntersecting ? "running" : "paused";
        });
      }, {
        threshold: 0.01
      });
      this.intersectionObserver.observe(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$intersectionObs;
      (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.disconnect();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkeditiondk"] = self["webpackChunkeditiondk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;